/**
 * Shared expiry presets for external (email) share links.
 * Empty / forever => no expires_at (link never expires).
 */
export const SHARE_EXPIRY_OPTIONS = [
  { value: 'forever', label: 'Forever' },
  { value: '1h', label: '1 hour' },
  { value: '24h', label: '24 hours' },
  { value: '7d', label: '7 days' },
  { value: '30d', label: '30 days' },
  { value: '90d', label: '90 days' },
];

/**
 * @param {string} key - SHARE_EXPIRY_OPTIONS value
 * @returns {string|null} ISO timestamp or null for forever
 */
export function computeExpiresAt(key) {
  if (!key || key === 'forever') return null;

  const now = new Date();
  if (key.endsWith('h')) {
    const hours = parseInt(key, 10);
    if (!hours) return null;
    now.setHours(now.getHours() + hours);
    return now.toISOString();
  }
  if (key.endsWith('d')) {
    const days = parseInt(key, 10);
    if (!days) return null;
    now.setDate(now.getDate() + days);
    return now.toISOString();
  }

  // Legacy numeric days (e.g. "7")
  const days = parseInt(key, 10);
  if (!days) return null;
  now.setDate(now.getDate() + days);
  return now.toISOString();
}

export function formatShareExpiry(expiresAt) {
  if (!expiresAt) return 'Forever';
  const date = new Date(expiresAt);
  if (Number.isNaN(date.getTime())) return 'Forever';
  if (date < new Date()) return 'Expired';
  return `Expires ${date.toLocaleDateString()} ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
}
